import type { ReactNode } from 'react';

export const symbol_hr_resting: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M150-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h660q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm67-384q-29-27-42.5-64T161-644q0-81 55.5-138.5T352-840q36 0 69 13t59 38q26-25 59-38t69-13q81 0 136.5 58T800-643q0 39-14.5 74.5T744-505L535-302q-11 11-25 16.5t-30 5.5q-16 0-30-5.5T425-302L217-504Zm42-42 221 214 223-215q20-19 29-44.08 9-25.09 9-51.92 0-56-38.32-96t-93.74-40q-25.94 0-50.1 10.05Q534.68-758.91 517-740l-22 22q-3.08 3-6.93 4.5-3.85 1.5-7.96 1.5-4.11 0-7.61-1.5T466-718l-22-22q-19.2-18.82-42.6-29.41Q378-780 352-780q-54.97 0-92.99 40Q221-700 220-644q0 27.12 9.5 53.06T259-546Zm221-10Z"
		/>
	</svg>
);
